import $ from 'jquery';

const scrollToTop = {
  init : (elementHtmlTag, cssSelectorOfFocusElement) => {
    cssSelectorOfFocusElement = cssSelectorOfFocusElement || false;

    /*
    * Add event
    * */
    $(elementHtmlTag).on('click', (e) => {
      scrollToTop.scroll(elementHtmlTag, cssSelectorOfFocusElement);
    });
  },
  scroll : (elementHtmlTag, cssSelectorOfFocusElement) => {
    let focusElementOffset = 0;

    if (cssSelectorOfFocusElement && $(cssSelectorOfFocusElement).length > 0) {
      focusElementOffset = $(cssSelectorOfFocusElement).offset().top;
    }

    $('html, body').animate(
      {
        scrollTop : focusElementOffset
      },
      500
    );
  }
};

export default scrollToTop;
